export default "__VITE_ASSET__DaJ1rVQr__"